<template>
  <div class="d-flex flex-column">
    <div class="row justify-content-between mb-4">
      <div class="col-12 col-sm-4 d-flex">
        <card :title="$t('sections.ordLandingPage.numbers.title')" divider>
          <div class="row">
            <div class="d-flex flex-column col-auto">
              <HorizontalDetailTitle
              :label="$t('sections.ordLandingPage.numbers.integratedCPEs')" />
              <HorizontalDetailTitle
              :label="$t('sections.ordLandingPage.numbers.nonintegratedCPEs')" />
              <HorizontalDetailTitle
              :label="$t('sections.ordLandingPage.numbers.existingORDs')" />
            </div>
            <div class="d-flex flex-column col-auto flex-fill pl-4">
              <HorizontalDetailInput
              :field="numbers.integratedCPEs"
              :edit="false" />
              <HorizontalDetailInput
              :field="numbers.nonintegratedCPEs"
              :edit="false" />
              <HorizontalDetailInput
              :field="numbers.existingCPEs"
              :edit="false" />
            </div>
          </div>
        </card>
      </div>
    </div>

    <PaginationWrapper
    :page="page"
    :totalCount="totalCount"
    @onPageChange="handlePageChange"
    export
    @exportTable="exportList">
      <div slot="table">
        <span class="section-title">
        {{ $t("sections.ordLandingPage.tableToIntegrate.title") }}
      </span>
        <base-table :data="getCPEsToIntegrate">
        <el-table-column
        prop="cpe"
        :label="$t('sections.ordLandingPage.tableToIntegrate.cpe')" />
        <el-table-column prop="location_id"
        :label="$t('sections.ordLandingPage.tableToIntegrate.location')" />
        <el-table-column
        :label="$t('sections.ordLandingPage.tableToIntegrate.submitedDate')">
          <template slot-scope="props">
            {{
              props.row.requestDate
              ? formatTime(props.row.requestDate)
              : props.row.requestDate
            }}
          </template>
        </el-table-column>
        <el-table-column
        :label="$t('sections.ordLandingPage.tableToIntegrate.numberOfDays')">
          <template slot-scope="props">
            {{
              dateDifference(props.row.requestDate)
            }}
          </template>
        </el-table-column>
      </base-table>
      </div>
    </PaginationWrapper>
  </div>
</template>
<script>
import { formatTime } from '@/utils';
import { mapGetters } from 'vuex';
import HorizontalDetailTitle from '@/components/ui/HorizontalDetailTitle.vue';
import HorizontalDetailInput from '@/components/ui/HorizontalDetailInput.vue';
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';

export default {
  name: 'ORDsManagerLandingPage',
  components: {
    HorizontalDetailTitle,
    HorizontalDetailInput,
    PaginationWrapper,
  },
  data() {
    return {
      query: {},
      page: 1,
      numbers: {
        integratedCPEs: 0,
        nonintegratedCPEs: 0,
        existingCPEs: 0,
      },
      totalCount: 0,
    };
  },
  computed: {
    ...mapGetters(['getLoading', 'getCPEsIntegrated', 'getCPEsToIntegrate']),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      try {
        const cpesCount = await this.$store.dispatch('getCPEsStatistics');

        this.numbers.existingCPEs = cpesCount.cpesTotalCount;
        this.totalCount = cpesCount.cpesCount.cpeStatusNotIntegrated;

        this.numbers.integratedCPEs = cpesCount.cpesCount.cpeStatusIntegrated;
        this.numbers.nonintegratedCPEs = cpesCount.cpesCount.cpeStatusNotIntegrated;
      } catch (e) {
        console.log("Couldn't get ords analytics.");
      }

      await this.$store.dispatch('storeCPEsIntegrated', {
        query: this.query,
        page: this.page,
      });

      await this.$store.dispatch('storeCPEsToIntegrate', {
        query: this.query,
        page: this.page,
      });

      this.$store.dispatch('storeLoading', false);
    },
    formatTime,
    dateDifference(submitedDate) {
      const cpeDate = new Date(submitedDate);
      const currentDate = new Date();
      const diff = currentDate.getTime() - cpeDate.getTime();

      return Math.floor(diff / (1000 * 3600 * 24));
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: {
            cpeStatus: 'NotIntegrated',
          },
          type: 'cpes',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', {
              type: 'cpes',
            }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `cpes-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'cpes' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'cpes' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
